import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

import { getCurrencyAmount } from "./../../../utils/stringUtils";

import Table from "../../../components/common/Table";
import Pagination from "../../../components/common/Pagination";
import Toaster from "../../../components/common/Toaster";

import journalService from "../../../services/journalService";
import moment from "moment";

const UnpostedEntriesTable = (props) => {
  const { data, columns, options, onChange, setData } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await journalService.getUnpostedEntriesAsync(options);
        const { result, page, total_count } = response;

        const items = result.map((item) => {
          item["date_value"] = item.date_issued;
          item["date_issued"] = moment(item.date_issued).format("DD-MMM-yyyy");
          item["gross"] = item.gross_amount;
          item["withheld"] = item.withheld_amount;
          item["discount"] = item.discount_amount;
          item["net"] = item.net_amount;
          item["gross_amount"] = getCurrencyAmount(item.gross_amount);
          item["withheld_amount"] = getCurrencyAmount(item.withheld_amount);
          item["discount_amount"] = getCurrencyAmount(item.discount_amount);
          item["net_amount"] = getCurrencyAmount(item.net_amount);

          item["name"] = (
            <Link
              className="hover:text-blue-400"
              to={`/accounts/${item.account_id}`}
            >
              {item.name}
            </Link>
          );

          return item;
        });

        if (mounted) {
          setData(items);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        setIsLoading(false);
        Toaster.Error("Something went wrong.");
      }
    },
    [options, setData]
  );

  const handleSort = (sort_column) => {
    const new_options = { ...options };
    new_options.sort_column = sort_column;
    onChange(new_options);
  };

  const handlePageChange = (page) => {
    const new_options = { ...options };
    new_options.current_page = page;
    onChange(new_options);
  };

  useEffect(() => {
    let mounted = true;

    fetchData(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchData]);

  return (
    <div className="mt-10 overflow-auto">
      <Table
        data={data}
        columns={columns}
        sortColumn={options.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={options.size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default UnpostedEntriesTable;
